import dayjs from 'dayjs';

export const useChronologicalService = () => {
  // Repositories
  const { getChronologicalConsumption, getChronologicalProduction, getChronologicalTemperature, getComparisonConsumption } =
    useChronologicalRepository();

  // Store
  const { period, energyType, areaId, aggregationLevel, showTemperature } = storeToRefs(exploreStore());
  const { areasToCompare } = storeToRefs(chronologicalStore());
  const { selectedSite } = storeToRefs(globalStore());
  const { getSite } = siteStore();

  const loadChronologicalData = () => {
    const siteId = selectedSite.value[0];
    if (!siteId) return;
    const site = getSite(siteId);
    const dateFormat = ['day', 'week', 'month'].includes(aggregationLevel.value) ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm';

    getChronologicalConsumption({
      energyType: energyType.value,
      start: dayjs(period.value.start).format(dateFormat),
      end: dayjs(period.value.end).format(dateFormat),
      aggregationLevel: aggregationLevel.value,
      areaId: areaId.value,
    });

    getChronologicalProduction({
      energyType: energyType.value,
      areaId: areaId.value,
      start: dayjs(period.value.start).format(dateFormat),
      end: dayjs(period.value.end).format(dateFormat),
    });

    if (aggregationLevel.value === 'day' && site?.weather_station_id && showTemperature.value) {
      getChronologicalTemperature({
        siteId: siteId,
        start: dayjs(period.value.start).format(dateFormat),
        end: dayjs(period.value.end).format(dateFormat),
      });
    }
  };

  const loadComparisonData = () => {
    const dateFormat = ['day', 'week', 'month'].includes(aggregationLevel.value) ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm';

    getComparisonConsumption({
      energyType: energyType.value,
      start: dayjs(period.value.start).format(dateFormat),
      end: dayjs(period.value.end).format(dateFormat),
      aggregationLevel: aggregationLevel.value,
      areaId: areaId.value,
      areaToCompare: areasToCompare.value.map((area) => ({
        id: area.id,
        start: dayjs(area.start).format(dateFormat),
      })),
    });
  };

  return { loadChronologicalData, loadComparisonData };
};
